// extracted by mini-css-extract-plugin
export default {"separator":"HorizontalSeparator_separator__5d6Xy"};